module.exports = __webpack_public_path__ + "img/Logo-1-p-800.edbf457c.png";